import {ExecutorStatus} from './executor-status.model';
import {BaseEmployeeModel} from '../../base-employee/models/base-employee.model';

export class ExecutorModel {
  id: number;
  projectName: string;
  birth_date: string;
  birth_date_timestamp: number;
  registration_date_timestamp: number;
  confirmed_terms_of_use: boolean;
  email: string;
  email_confirmation_date: string;
  executor_photo: string;
  first_name: string;
  last_name: string;
  middle_name: string;
  login: string;
  phone: string;
  project_country_id: number;
  project_id: number;
  region_id: number;
  removed_at: number;
  status: ExecutorStatus;
  uid: string;
  last_request_os_type: string;
  last_request_os_version: string;
  last_request_device_vendor: string;
  last_request_device_model: string;
  last_request_user_agent: string;
  last_request_client_name: string;
  last_request_client_version: string;
  employees: Array<BaseEmployeeModel>;
  currentEmployee: BaseEmployeeModel;
}
